import Api from '@/core/api';

export interface ClapsConfig {
    readonly: boolean
    useMetadata: boolean
    maxClapsPerThrottle: number
    throttleTime: number
}

export default class ClapsController {
    private api: Api;

    constructor(
        api: Api,

        private clapsToAnimate = 0,
        private totalClaps = 0,
        private _newClaps = 0,
        private _throttledClaps = 0,
        private _skipRound = true
    ) {
        this.api = api;
    }

    public setNewClaps(newTotal: number, newPartial = 0): void {
        // When skipRound is true it means user seeked through the video, in which case the newTotal might be much greater,
        // so we cannot blindly use it. totalClaps needs to be reset to work for both seek forward and backward.
        if (this._skipRound) {
            this.totalClaps = newTotal;
            this.clapsToAnimate += newPartial;
            this._skipRound = false;
            return;
        }

        const newClaps = newTotal - this.totalClaps;

        this.totalClaps = Math.max(this.totalClaps, newTotal);

        this.clapsToAnimate += newClaps;
    }

    public incrementCounters(): void {
        this._newClaps++;
        this._throttledClaps++;
    }

    public sendClaps(): void {
        if (this._newClaps === 0) return;

        this.api.customAction(this._newClaps, 'claps');

        this.totalClaps += this._newClaps;
        this._newClaps = 0;
    }

    // getters and setters

    public set skipRound(skip: boolean) {
        this._skipRound = skip;
    }

    public consumeOneClap(): boolean {
        if (this.clapsToAnimate <= 0) {
            return false;
        }
        this.clapsToAnimate--;
        return this.clapsToAnimate >= 0;
    }

    public get throttledClaps(): number {
        return this._throttledClaps;
    }

    public set throttledClaps(claps: number) {
        this._throttledClaps = claps;
    }
}
